import type { SuiteExecutionStatusSummaryDto } from '@flowqa/shared';
export {
  resolveFrequencyPerDay,
  resolveTimestamp,
} from '@/features/shared/metrics/detailExecutionMetrics';

export const resolvePassRateFromSummary = (
  summary: SuiteExecutionStatusSummaryDto | null,
): number | null => {
  if (!summary) return null;
  const total = summary.total - summary.untested;
  if (total <= 0) return null;
  const value = (summary.passed / total) * 100;
  return Number.isFinite(value) ? value : null;
};
